export default __webpack_public_path__ + "static/customer-service-management_app_light-ff7a4e0c182b2185dcedb560d13f262f.svg";